import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=65dfbb5c&scoped=true"
import script from "./Header.vue?vue&type=script&setup=true&lang=ts"
export * from "./Header.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Header.vue?vue&type=style&index=0&id=65dfbb5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65dfbb5c",
  null
  
)

export default component.exports